import React, { useState } from 'react';
import CategoryDemoContext from './context';

/**
 * withCategoryDemo higher order component
 * Defines context and state of the Categories & Demos
 * @param {*} Component 
 */
const withCategoryDemo = Component => {

    // Internal component to handle context and state
    function Comp(props) {

        // State
        const [categoryDemoData, setCategoryDemoData] = useState(null);

        return (
            <CategoryDemoContext.Provider value={{ categoryDemoData, setCategoryDemoData }}>
                <Component {...props} />
            </CategoryDemoContext.Provider>
        );

    }

    return Comp;
};

export default withCategoryDemo;